<template>
  <div>
    <div class="position__cardBorder">
      <div class="position__contentWrapper">
        <div class="position__titlesWrapper">
          <div class="position__titlesWrapper__title">
            {{ optionValue.Text }}
          </div>
          <div class="position__titlesWrapper__positionFor">
            {{ optionValue.Value }}
          </div>
        </div>
        <div
          v-if="true === optionValue.IsThirdPartyProduct"
          class="position__priceWrapper"
        >
          <div class="position__priceWrapper__price">
            Included
          </div>
        </div>
        <div v-else class="position__priceWrapper-login">
          <div v-if="null !== optionValue.Price">
            <div v-if="showLoginMsg" class="position__login">
              <legrandav-link label="Sign in" @click="onLoginClick"></legrandav-link>
            </div>
            <div v-else class="position__priceWrapper">
              <div class="position__priceWrapper__price">
                {{ optionValue.Price.FormattedPrice }}
              </div>
              <div class="position__priceWrapper__msrp">
                {{ optionValue.Price.FormattedMSRP }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position__positionWrapper">
        <div class="position__positionWrapper__header">
          {{ optionValue.ModalLabelText }}
        </div>
        <div
          class="position__positionWrapper__radios"
          :data-enhanced-radio="optionValue.Text"
        >
          <div v-for="(position, index) in optionValue.Position" :key="index">
            <!-- <label class="position__positionWrapper__label" for="left"> -->
            <div>
              <input
                type="radio"
                :id="optionValue.Value + '-' + index"
                :value="position.PositionValue"
                v-model="selectedPosition"
                @change="selectOption(optionValue, $event)"
                :disabled="validPos(optionValue, position.PositionValue)"
              />
              <label
                v-bind:class="{
                  disabledPos: validPos(optionValue, position.PositionValue)
                }"
                class="checkmark"
                :for="optionValue.Value + '-' + index"
              >
                {{ position.PositionName }}</label
              >
            </div>
            <!-- <input
              class=""
              type="checkbox"
              :id="optionValue.Value + '-' + index"
              :value="position.PositionValue"
              v-model="selectedPosition"
            />
            <label :for="optionValue.Value + '-' + index">{{
              position.PositionName
            }}</label> -->
            <!-- <span class="position__positionWrapper__checkmark">
                <span class="material-icons">
                  check
                </span>
              </span>
              {{ position }}</label
            > -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UtilityService from "../../services/UtilityService";
export default {
  props: {
    optionValue: {
      type: Object,
      default: function() {
        return [];
      }
    }
  },
  mounted() {
    if (
      this.getSelectedOptions &&
      this.getSelectedOptions[this.optionValue.EnhancedSectionId] &&
      this.getSelectedOptions[this.optionValue.EnhancedSectionId][
        this.optionValue.Value
      ] &&
      this.getSelectedOptions[this.optionValue.EnhancedSectionId][
        this.optionValue.Value
      ].Position
    ) {
      this.selectedPosition = this.getSelectedOptions[
        this.optionValue.EnhancedSectionId
      ][this.optionValue.Value].Position;
      this.$store.dispatch("enhancedproduct/setCutoutPositionValidation", {
        rulesKey: this.getSelectedOptions[this.optionValue.EnhancedSectionId][
          this.optionValue.Value
        ].RulesKey,
        sectionId: this.getSelectedOptions[this.optionValue.EnhancedSectionId][
          this.optionValue.Value
        ].EnhancedSectionId,
        checked: true,
        positionKey: this.getSelectedOptions[
          this.optionValue.EnhancedSectionId
        ][this.optionValue.Value].Position,
        value: this.getSelectedOptions[this.optionValue.EnhancedSectionId][
          this.optionValue.Value
        ].Value
      });
    }
  },
  data() {
    return {
      selectedPosition: ""
    };
  },
  computed: {
    ...mapGetters("enhancedproduct", ["getSelectedOptions", "getSections"]),
    ...mapGetters("user", ["getIsUserLoggedIn"]),
    showLoginMsg() {
      // Price object isn't set
      const { Price } = this.optionValue;
      if (null === Price) {
        return false;
      }
      // logged in
      if (this.getIsUserLoggedIn) {
        return false;
      }
      // not logged in and price object exists
      else {
        const priceStr = this.optionValue.Price.FormattedPrice;
        return priceStr.toLowerCase().includes("please");
      }
    }
  },
  methods: {
    selectOption(optionValue, event) {
      let selectedObj = JSON.parse(JSON.stringify(optionValue));
      selectedObj.Position = this.selectedPosition;
      selectedObj.DefaultQuantity = this.selectedPosition.length;
      let selectedOptionFinalObj = {};
      selectedOptionFinalObj[optionValue.Value] = selectedObj;
      for (let i = 0; i < optionValue.Position.length; i++) {
        if (
          this.isPositionSelected(
            optionValue,
            optionValue.Position[i].PositionValue
          )
        ) {
          this.$store.dispatch("enhancedproduct/setCutoutPositionValidation", {
            rulesKey: optionValue.RulesKey,
            sectionId: optionValue.EnhancedSectionId,
            checked: false,
            positionKey: optionValue.Position[i].PositionValue,
            value: optionValue.Value
          });
        }
      }

      this.$store.dispatch("enhancedproduct/setCutoutPositionValidation", {
        rulesKey: optionValue.RulesKey,
        sectionId: optionValue.EnhancedSectionId,
        checked: event.target.checked,
        positionKey: event.target.value,
        value: optionValue.Value
      });
      this.$emit(
        "select-position",
        selectedOptionFinalObj,
        optionValue.RulesKey,
        optionValue.Value,
        event.target.checked
      );
    },
    validPos(optionValue, value) {
      if (
        this.getSections &&
        this.getSections[optionValue.EnhancedSectionId] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ][optionValue.RulesKey] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ][optionValue.RulesKey][value]
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPositionSelected(optionValue, value) {
      if (
        this.getSections &&
        this.getSections[optionValue.EnhancedSectionId] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ][optionValue.RulesKey] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ][optionValue.RulesKey][value] &&
        this.getSections[optionValue.EnhancedSectionId][
          "cutoutPositionsForValidation"
        ][optionValue.RulesKey][value] == optionValue.Value
      ) {
        return true;
      } else {
        return false;
      }
    },
    onLoginClick() {
      UtilityService.openSignInMenu();
      this.$store.dispatch("enhancedproduct/updateEnhancedLocalStorage");
    }
  }
};
</script>

<style lang="scss" scoped>
.position {
  &__header {
    margin-bottom: 30px;

    &__placement {
      font-family: $font-family-sans-serif-medium;
      font-size: 14px;
      letter-spacing: 1px;
      line-height: 24px;
      text-transform: uppercase;
      color: $gray-dark;
      margin-bottom: 10px;
    }

    &__image {
      height: 90px;
      border: 1px solid $gray;
    }
  }

  &__cardBorder {
    border: 1px solid $gray-light;
    margin-bottom: 20px;
  }

  &__contentWrapper {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $gray-light;
    flex-direction: column;
    @include media-breakpoint-up(sm) {
      flex-direction: row;
    }
  }

  &__titlesWrapper {
    display: flex;
    flex-direction: column;
    max-width: 70%;

    &__title {
      color: $gray-darker;
      font-family: $font-family-sans-serif-medium;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.25px;
      line-height: 24px;
      margin: 10px 0 4px 10px;
    }

    &__positionFor {
      font-family: $font-family-base;
      color: $gray-dark;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.25px;
      line-height: 18px;
      margin: 0 0 10px 10px;
    }
  }

  &__priceWrapper {
    display: flex;
    flex-direction: column;

    &-login {
      display: flex;
      flex-direction: column;
      align-self: center;
    }
    &__price {
      color: $gray-darker;
      font-family: $font-family-sans-serif-medium;
      font-size: 16px;
      letter-spacing: 0.25px;
      line-height: 24px;
      text-align: left;
      margin: 0 10px 4px 10px;

      @include media-breakpoint-up(sm) {
        margin: 10px 10px 4px 0;
        text-align: right;
      }
    }

    &__msrp {
      font-family: $font-family-base;
      color: $gray-dark;
      font-size: 12px;
      letter-spacing: 0.25px;
      line-height: 18px;
      text-align: left;
      margin: 0 10px 10px 10px;
      @include media-breakpoint-up(sm) {
        margin: 0 10px 10px 0;
        text-align: right;
      }
    }
  }

  &__positionWrapper {
    display: flex;
    flex-direction: column;
    background-color: $gray-lighter;

    &__header {
      font-family: $font-family-base;
      color: $gray-dark;
      font-size: 14px;
      letter-spacing: 0.25px;
      margin: 10px 0 4px 10px;
    }

    &__radios {
      display: flex;
      flex-direction: row;
      margin: 0 10px 10px 10px;

      div {
        margin: 0 30px 0 0;
      }
      div:last-child {
        margin: 0;
      }
    }

    &__radio {
      left: unset;
      position: unset;
      opacity: 0;
    }

    &__label {
      font-family: $font-family-base;
      font-size: 16px;
      letter-spacing: 0.25px;
      line-height: 24px;
      font-weight: normal;
      display: block;
      position: relative;
      padding-left: 23px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      margin-bottom: 0px;

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        &:checked {
          ~ {
            .position__positionWrapper__checkmark {
              background-color: $aqua;
              border: 1px solid $aqua;
              &:after {
                display: block;
              }
            }
          }
        }
      }

      &:hover {
        input {
          ~ {
            .position__positionWrapper__checkmark {
              background-color: $aqua;
              border: 1px solid $aqua;
            }
          }
        }
      }

      .position__positionWrapper__checkmark {
        &:after {
          // top: 9px;
          // left: 9px;
          // width: 8px;
          // height: 8px;
          // background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white' width='18px' height='18px'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z'/%3E%3C/svg%3E");
          // background-repeat: no-repeat;
          // background-color: white;
          // background-position: center;
        }
      }
    }

    &__checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 18px;
      width: 18px;
      background-color: $white;
      border: 1px solid #b2b2b2;
      margin: 2px 0 0;

      &:after {
        content: "";
        position: absolute;
        display: none;
      }

      span {
        color: $white;
        font-size: 16px;
      }
    }
  }
  &__login {
    margin: auto 10px auto 0;
    a {
      color: $aqua;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

/* The container */
.container-checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-family: $font-family-sans-serif-regular;
  font-size: 16px;
  letter-spacing: 0.25px;
  line-height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: normal;
}

/* Hide the browser's default checkbox */
.container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.container-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 1px solid rgb(178, 178, 178);
  cursor: pointer;

  &.disabledPos {
    cursor: not-allowed;
    background: #d7d7d7;
  }
}

/* On mouse-over, add a grey background color */
.container-checkbox:hover input ~ .checkmark {
  background-color: #fff;
  border: 1px solid rgb(178, 178, 178);

  &.disabledPos {
    cursor: not-allowed;
    background: #d7d7d7;
  }
}

/* When the checkbox is checked, add a blue background */
.container-checkbox input:checked ~ .checkmark {
  background-color: $aqua;
}

/* Create the checkmark/indicator (hidden when not checked) */
.container-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container-checkbox .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  display: inline-block;
  color: #666;
  font-family: $font-family-sans-serif-regular;
  font-size: 16px;
  letter-spacing: 0.25px;
  line-height: 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: normal;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: $aqua;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.disabledPos::before {
  cursor: not-allowed;
  background: #d7d7d7 !important;
}
</style>
